import { bn } from './number'

export class Equal {
  static lowerCase(a: string, b: string) {
    if (!a || !b) return false
    return a.toLowerCase() === b.toLowerCase()
  }
  static upperCase(a: string, b: string) {
    if (!a || !b) return false
    return a.toUpperCase() === b.toUpperCase()
  }
  static address(a: string, b: string) {
    return this.lowerCase(a, b)
  }
  static tokenSymbol(a: string, b: string) {
    return this.upperCase(a, b)
  }
  static chainId(a: string | number, b: string | number) {
    if (!a || !b) return false
    return bn(a).eq(bn(b))
  }
}
